module.exports = __webpack_public_path__ + "img/UHFsensorTransformer.2b9227f0.png";